<template>
  <div class="teach-learn">
    <van-nav-bar
      title="课程表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <!-- 顶部课程卡片 -->
    <div v-for="item of courseList" class="main-card">
      <div class="main-header"  @click="toggleExpand(item.onlineCourseId)">
        <div class="main-title ellipsis">{{ item.onlineCourseName }}</div>
        <img
          :src="expandedIndex === item.onlineCourseId ? require('@/assets/icons/down-arrow.png') : require('@/assets/icons/right-arrow.png')"
          class="arrow-icon"
        />
      </div>
      <div class="main-desc ellipsis-2">简介：{{ item.onlineCourseDescription }}</div>
      <div class="main-time" v-if="expandedIndex === item.onlineCourseId">
        时间：{{ item.startTime }} ~ {{ item.endTime }}
      </div>
     
      <div class="main-credit-row" v-if="expandedIndex === item.onlineCourseId">
        <span class="main-credit-label">学分：</span>
        <span class="main-credit-link" @click.stop="getCertificate(item.onlineCourseId)">查看学分</span>
      </div>
      <!-- 展开内容 -->
      <transition name="fade">
        <div v-if="expandedIndex === item.onlineCourseId" class="expand-content">
          <div class="section-row resource-section-row">
            <span class="section-label">教学资源</span>
          </div>
          <ResourceList :resources="resources" :isearnCredit="true" :isStudents="isStudents"/>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import ResourceList from '@/components/ResourceList.vue';
import { myStudy,myStudyDetail,isStudents } from "@/api/teach/courseList";
import { judgeClient, isWeChatBrowser, closeIos, closeAndroid } from '@/utils/index.js';
import wx from 'weixin-js-sdk'

export default {
  name: 'TeachLearn',
  components: { ResourceList },
  data() {
    return {
        courseList:[],
        resourceCollapsed: true,
        resources:[],
        progress: 8,
        progressTotal: 16,
        expandedIndex: null,
        isStudents: "",
        // onlineCourseId: "",
        // paperDTOList: [],
        // onlineCourseResourceId: [],
    }
  },
  computed: {
    progressPercent() {
      return Math.round((this.progress / this.progressTotal) * 100)
    }
  },
  created(){
    window.addEventListener("tokenEvent",( event )=>{
      this.getMyStudy();
    }, false);
    this.getIsStudents();
    this.getMyStudy();
  },
  methods: {
    onClickLeft() {
       if( localStorage.getItem("source")){
        wx.miniProgram.postMessage({
          data: {
            action:"back",
            title: 'ceshi'
          }
        })
        wx.miniProgram.navigateBack()

      }else{
        if (judgeClient() == "Android") {
          this.closeAndroid();
        } else {
          this.closeIos();
        }

      }
      
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    getCertificate( onlineCourseId ){
      this.$router.push({
        path:"/teachLearnCertificate",
        query:{
          onlineCourseId
        }
      })
    },
     getMyStudyDetail( id ){
      myStudyDetail( id ).then( res => {
        if( res.code==200 ){
          res.data.forEach( ele => {
            // ele.fileUrl="https://file.medmeta.com/web/voice/am.mp3";
            // ele.fileUrl="https://file.medmeta.com/web/video/skillAbility.mp4";
            // ele.fileUrl="https://file.medmeta.com/web/images/YCshareImg.png";
          });
          console.log("*******",  res.data)
          this.resources = res?.data;

        }

      })
    },
    async getIsStudents() {
      const data = await isStudents();
      this.isStudents = data.data;
    },
    getMyStudy(){
      myStudy().then( res => {
        this.courseList = res?.data;
      })
    },
    toggleResource() {
      this.resourceCollapsed = !this.resourceCollapsed;
    },
    toggleExpand(id) {
      console.log(this.expandedIndex,"???????????????",id);
      this.expandedIndex = this.expandedIndex === id ? null : id;
      if(this.expandedIndex){
        this.getMyStudyDetail( this.expandedIndex );

      }

    },

  }
}
</script>

<style scoped lang="scss">
.teach-learn {
  background: #f8f9fb;
  min-height: 100vh;
  .van-nav-bar{
    margin-bottom: 16px;
  }
  .main-card {
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 18px 16px 10px 16px;
    margin: 0 12px 16px 12px;
    .main-header {
      display: flex;
      align-items: center;
      cursor: pointer;
      .main-title {
        flex: 1;
        font-weight: 500;
        font-size: 16px;
        color: #2F2F46;
        line-height: 24px;
        margin-right: 8px;
      }
      .arrow-icon {
        width: 18px;
        height: 18px;
        transition: transform 0.2s;
      }
    }
    .main-desc {
      color: #8f91a1;
      font-size: 13px;
      margin: 6px 0 8px 0;
      line-height: 20px;
    }
    .main-time {
      color: #8f91a1;
      font-size: 13px;
      margin-bottom: 8px;
    }
    .main-credit-row {
      font-size: 13px;
      margin-bottom: 8px;
      .main-credit-label {
        color: #8f91a1;
      }
      .main-credit-link {
        color: #347aff;
        cursor: pointer;
        margin-left: 2px;
        text-decoration: none;
      }
    }
    .expand-content {
      .main-info-row {
        color: #8f91a1;
        font-size: 13px;
        margin: 8px 0 4px 0;
        display: flex;
        gap: 18px;
        align-items: center;
        .main-link {
          color: #347aff;
          cursor: pointer;
          margin-left: auto;
        }
      }
      .section-row {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 500;
        margin: 12px 0 8px 0;
        .section-label {
          color: #222;
        }
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    height: 0;
  }
  .ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ellipsis-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
